export default {
  siteLists(model) {
    return window.restApi.get("Avigilon/dashboard/site", { params: model });
  },
  areaLists(model) {
    return window.restApi.get("Avigilon/dashboard/area", { params: model });
  },
  cameraLists(model) {
    return window.restApi.get("Avigilon/dashboard/camera", { params: model });
  },
  cameraView(model) {
    return window.restApi.get("Avigilon/camera/view", { params: model });
  },
  masterCamera(model) {
    return window.restApi.get("Master/camera", { params: model });
  },
  graphData(model) {
    return window.restApi.get("Avigilon/dashboard/site/chart", {
      params: model,
    });
  },

  // View API
  viewList() {
    return window.restApi.get("/View/GetData");
  },
  viewDetail(model) {
    return window.restApi.get("/View/ShowDetailView", { params: model });
  },
  viewCameraTree() {
    return window.restApi.get("/View/GetCameraTree");
  },
  viewSave(model) {
    return window.restApi.post("/View/save", model);
  },
  viewDelete(model) {
    return window.restApi.post("/View/delete", model);
  },
  viewDownload(model) {
    return window.restApi.get("/View/video/download", { params: model });
  },
  viewBookmark(model) {
    return window.restApi.post("/Bookmark/save", model);
  },
  viewSnapshot(model) {
    return window.restApi.get("/View/video/snapshot", { params: model });
  },
  viewSkipVideo(model) {
    return window.restApi.get("/View/video/searchrecording", { params: model });
  },
  // new api
  postLogin(model) {
    return window.restApi.post("/User/login", model);
  },
  getProfile(model) {
    return window.restApi.get("/User/user/userprofile", {
      params: model,
    });
  },
  sites(model) {
    return window.restApi.get("/Site/GetData", {
      params: model,
    });
  },
  saveSite(model, isEdit) {
    if (isEdit) {
      return window.restApi.post("/Site/update", model);
    } else {
      return window.restApi.post("/Site/save", model);
    }
  },
  deleteSite(model) {
    return window.restApi.post("/Site/delete", model);
  },
  areas(model) {
    return window.restApi.get("/Area/GetData", {
      params: model,
    });
  },
  deleteArea(model) {
    return window.restApi.post("/Area/delete", model);
  },
  saveArea(model, isEdit) {
    if (isEdit) {
      return window.restApi.post("/Area/update", model);
    } else {
      return window.restApi.post("/Area/save", model);
    }
  },
  cameras(model) {
    return window.restApi.get("/Camera/GetData", {
      params: model,
    });
  },
  general(model) {
    return window.restApi.get("/General/GetData", {
      params: model,
    });
  },
  saveGeneral(model) {
    return window.restApi.post("/General/update", model);
  },
  bookmarks(model) {
    return window.restApi.get("/bookmark/GetData", {
      params: model,
    });
  },
  bookmarkDetail(model) {
    return window.restApi.get("/Bookmark/ShowDetail", { params: model });
  },
  bookmarkUpdate(model) {
    return window.restApi.post("/Bookmark/update", model);
  },
  bookmarkDelete(model) {
    return window.restApi.post("/Bookmark/delete", model);
  },
  users(model) {
    return window.restApi.get("/User/user/list", {
      params: model,
    });
  },
  saveUser(model, isEdit) {
    if (isEdit) {
      return window.restApi.post("/User/user/update", model);
    } else {
      return window.restApi.post("/User/user/create", model);
    }
  },
  adminLists(model) {
    return window.restApi.get("/General/GetAdminCombo", {
      params: model,
    });
  },
  freeCam(model) {
    return window.restApi.get("/Area/GetFreeCamera", {
      params: model,
    });
  },
  addedCam(model) {
    return window.restApi.get("/Area/GetAddedCamera", {
      params: model,
    });
  },
  reportData(path, model) {
    return window.restApi.get(path, {
      params: model,
    });
  },
  updateCamera(model) {
    return window.restApi.post("/Camera/update", model);
  },
  companies(model) {
    return window.restApi.get("/Company/GetData", {
      params: model,
    });
  },
  roles(model) {
    return window.restApi.get("/User/role/list", {
      params: model,
    });
  },
  saveCompany(model, isEdit) {
    if (isEdit) {
      return window.restApi.post("/Company/update", model);
    } else {
      return window.restApi.post("/Company/save", model);
    }
  },
  deleteCompany(model) {
    return window.restApi.post("/Company/delete", model);
  },
  uploadCamVoice(model) {
    return window.restApi.post("/Camera/voice/upload", model);
  },
  deleteUser(model) {
    return window.restApi.post("/User/delete", model);
  },
  importCamera(model) {
    return window.restApi.post("/Site/ImportCamera", model);
  },
  refreshCameras(model) {
    return window.restApi.get("/Site/UpdateRefreshCamera", {
      params: model
    });
  },
  siteInfo(model) {
    return window.restApi.post("/Site/GetSiteInfo", model);
  },
  movePTZ(model) {
    return window.restApi.post("/PTZ/action", model);
  },
  getEmbedSiteAccess(model) {
    return window.restApi.get("/EmbedAccess/GetEmbedSiteAccess", {
      params: model
    });
  },
  saveEmbedAccess(model) {
    return window.restApi.post("/EmbedAccess/save", model);
  },
  getEventLists(model) {
    return window.restApi.get("/ParameterEvent/GetData", {
      params: model
    });
  },
  getEventFilterLists(model) {
    return window.restApi.get("/ParameterEvent/GetDataFilter", {
      params: model
    });
  },
  getAksesCameraPerSite(model) {
    return window.restApi.get("/User/GetAksesCameraPerSite", {
      params: model
    });
  },
  getCustomReportCameraPerSite(model) {
    return window.restApi.get("/CustomReport/GetCustomReportCamera", {
      params: model
    });
  },
  getCustomReportLists(model) {
    return window.restApi.get("/CustomReport/GetData", {
      params: model
    });
  },
  saveCustomReport(model) {
    return window.restApi.post("/CustomReport/CreateData", model);
  },
  updateCustomReport(model) {
    return window.restApi.post("/CustomReport/UpdateData", model);
  },
  deleteCustomReport(customReportId) {
    return window.restApi.get("/CustomReport/DeleteData", { params: { customReportId } });
  },
  getAlarmLists(model) {
    return window.restApi.get("/AlarmLog/GetData", {
      params: model
    });
  },
  getAlarmDetail(id) {
    return window.restApi.get("/AlarmLog/ViewStreamingAlarm", {
      params: { alarmLogId: id}
    });
  },
  saveOtherCameraEvent(model) {
    return window.restApi.post("/Camera/SaveCameraOtherEvent", model);
  },
  updateOtherCameraEvent(model) {
    return window.restApi.post("/Camera/EditCameraOtherEvent", model);
  },
  deleteOtherCameraEvent(cameraOtherEventId) {
    return window.restApi.get("/Camera/DeleteCameraOtherEvent", { params: { cameraOtherEventId } });
  },
  getSelectedtCameraEventLists(model) {
    return window.restApi.get("/Camera/GetCameraOtherEvent", {
      params: model
    });
  },
  saveAksesCameraPerSite(model) {
    return window.restApi.post("/User/SaveAksesCameraPerSite", model);
  },
  getCustomReportGrafik(model) {
    return window.restApi.get("/CustomReportGrafik/reportchart", {
      params: model
    });
  },
  getCameraCustomReportSelection(model) {
    return window.restApi.get("/CustomReport/GetCameraCustomReportSelection", {
      params: model
    });
  },
  getStreamingOneCamera(model) {
    return window.restApi.get("/View/StreamingOneCamera", { params: model });
  },
};

// 1) GET /api/Avigilon/dashboard/allsite/chart?rangeParam=1 hour
// 2) GET /api/Avigilon/dashboard/site/chart?siteId=1&rangeParam=1 hour
// 3) GET /api/Avigilon/dashboard/area/chart?areaId=1&rangeParam=1 hour
// 4) GET /api/Avigilon/dashboard/camera/chart?cameraId=1&rangeParam=1 hour

// "GET /api/Avigilon/dashboard/allsite (return semua site)
// GET /api/Avigilon/dashboard/site?siteId=1 (return return area di dalam site)
// GET /api/Avigilon/dashboard/area?areaId=1 (return camera di dalam area)
// GET /api/Avigilon/dashboard/camera?cameraId=1 (return camera specific)"
